// 記載設定（WF進行条件）
export enum ProgressConditionKinds {
  None = 0,
  Any = 1,
  All = 2,
  AllOrdered = 3,
}

export class ProgressConditionKindsName {

  static getDisplayName(value: ProgressConditionKinds) {
    if (value === ProgressConditionKinds.None) { return "なし"; }
    if (value === ProgressConditionKinds.Any) { return "いずれか一人"; }
    if (value === ProgressConditionKinds.All) { return "全員"; }
    if (value === ProgressConditionKinds.AllOrdered) { return "全員（記載順あり）"; }

    return "";
  }
}
